import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const BASE = "https://customer-assets-0z36b82j.emergentagent.net/job_85938a33-e9d2-4396-b30a-3a2ddc28d1a7/artifacts/";

const IMAGES = [
  { src: `${BASE}8bca8b41aab6029a_IMG_2684.webp`, alt: "Feuerwerk über der Grömitzer Eisbahn", cls: "md:row-span-2" },
  { src: `${BASE}55772eb7f1c66db0_IMG_2694.webp`, alt: "Live-Band im Almhüttenzelt", cls: "md:col-span-2" },
  { src: `${BASE}a975a5469fa1ff0c_IMG_2573.webp`, alt: "Beleuchteter Außenbereich mit Tannenbäumen", cls: "md:row-span-2" },
  { src: `${BASE}0dea23dedcc3f72e_IMG_2891.webp`, alt: "Silvesterparty im Zelt", cls: "" },
  { src: `${BASE}cec2a5c3615fd1d6_IMG_2892.webp`, alt: "Tanzfläche im Almhüttenzelt", cls: "" },
];

export const SilvesterGallery = () => {
  const [active, setActive] = useState(null);

  return (
    <div className="max-w-6xl mx-auto mt-16" data-testid="silvester-gallery">
      <h3 className="text-2xl md:text-3xl font-medium text-white mb-8 text-center" style={{ fontFamily: 'Playfair Display' }}>
        Impressionen vom letzten Silvester
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-3 md:gap-4 md:h-[560px]">
        {IMAGES.map((img, i) => (
          <button
            key={img.src}
            type="button"
            onClick={() => setActive(img)}
            className={`group relative overflow-hidden rounded-2xl aspect-[4/3] md:aspect-auto ${i === 4 ? "col-span-2 md:col-span-1" : ""} ${img.cls}`}
            data-testid={`silvester-gallery-img-${i}`}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/20 transition-colors duration-300" />
          </button>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-5xl p-2 bg-slate-950 border-slate-800" data-testid="silvester-gallery-lightbox">
          <DialogTitle className="sr-only">{active?.alt}</DialogTitle>
          {active && <img src={active.src} alt={active.alt} className="w-full max-h-[85vh] object-contain rounded-lg" />}
        </DialogContent>
      </Dialog>
    </div>
  );
};
